function prepareFormDataJob (job) {
  return {
    id: job.id,
    executor: job.executor.name,
    description: job.description,
    job_type: job.job_type.name
  }
}

export {
  prepareFormDataJob
}
